export default {
    isOrder: (state: { isOrder: any; }) => state.isOrder
};
